<form [formGroup]="addTasksForm">
  <div class="uk-list task-lists">
    <div class="task-li uk-margin-remove uk-visible-toggle" uk-grid>
      <div
        class="uk-width-auto uk-padding-remove"
        [ngClass]="{ subtask: isChild }"
      >
        <div class="auto-box">
          <input
            class="uk-checkbox uk-border-circle"
            type="checkbox"
            formControlName="isCompleted"
          />
        </div>
      </div>
      <div class="uk-width-expand uk-padding-remove edit-icon-link">
        <input
          class="uk-input task-input-field"
          appAutoFocus
          formControlName="task_title"
        />
        <div *ngIf="!inEdit" class="task-description">{{ task.task_description }}</div>
        <div *ngIf="!inEdit" class="uk-width-auto uk-margin-remove uk-padding-remove">
          <button
            *ngIf="task.due_date"
            (click)="openModal()"
            class="uk-button uk-button-primary date-btn"
          >
            <span uk-icon="icon: calendar; ratio:0.8"></span
            >{{ task.due_date | dateAgo }} {{ task.due_time }}
          </button>
        </div>
      </div>
      <div
        class="uk-width-auto uk-padding-remove edit-icon-link"
        *ngIf="!inEdit"
      >
        <a [routerLink]="['edit/' + task.id]" uk-icon="icon: pencil"></a>
      </div>
    </div>
  </div>
</form>
<div *ngIf="task.parent_id === null">
  <ul class="uk-list">
    <li *ngFor="let task of tasks">
      <app-task-form
        [list]="list"
        [task]="task"
        [isChild]="true"
      ></app-task-form>
    </li>
  </ul>
</div>
